import { render } from "./ShowVideo.vue?vue&type=template&id=e2945fee&scoped=true"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"

import "./ShowVideo.vue?vue&type=style&index=0&id=e2945fee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2945fee"

export default script